/**
 * Sample games for the upload-flow previews. Both the app preview and the
 * community platform preview read these, and every team total, ranking, award
 * and table is derived from the per-player stats below so they always agree.
 *
 * Stat keys match TempStats.stat_data in the app. Events (community timeline
 * and momentum chart): [minute, type, colour, player, side].
 */

const FOOTBALL = {
  sport: 'football',
  home: 'Thunder FC',
  away: 'Red Lions',
  score: '3 - 2',
  community: 'Thursday Night Football',
  when: 'Thursday · 8:00 PM',
  dateLabel: 'Thu, Oct 29',
  timeLabel: '8:00 PM',
  datePlayed: '2026-10-29',
  hourSlot: '20:00',
  venueName: 'Sports Zone',
  venue: 'Main pitch',
  keyCode: 'TNF-4821',
  minutes: 60,
  you: 'Karl',
  scorersHome: [
    { name: 'Karl', times: "12', 54'", isYou: true },
    { name: 'Omar', times: "31'" },
  ],
  scorersAway: [
    { name: 'Sami', times: "40'" },
    { name: 'Jad', times: "57'" },
  ],
  players: [
    { name: 'Karl', side: 'A', rating: 8.6, s: { goals: 2, assists: 1, shots_on_target: 2, shots_off_target: 1, chances_created: 3, successful_dribbles: 5, saves: 0, successful_tib: 1 } },
    { name: 'Omar', side: 'A', rating: 7.9, s: { goals: 1, assists: 0, shots_on_target: 1, shots_off_target: 1, chances_created: 2, successful_dribbles: 3, saves: 0, successful_tib: 2 } },
    { name: 'Ali', side: 'A', rating: 7.4, s: { goals: 0, assists: 2, shots_on_target: 1, shots_off_target: 2, chances_created: 3, successful_dribbles: 4, saves: 0, successful_tib: 3 } },
    { name: 'Hadi', side: 'A', rating: 7.1, s: { goals: 0, assists: 0, shots_on_target: 0, shots_off_target: 1, chances_created: 1, successful_dribbles: 0, saves: 0, successful_tib: 4 } },
    { name: 'Marc', side: 'A', rating: 6.8, s: { goals: 0, assists: 0, shots_on_target: 0, shots_off_target: 0, chances_created: 0, successful_dribbles: 0, saves: 3, successful_tib: 1 } },
    { name: 'Sami', side: 'B', rating: 7.8, s: { goals: 1, assists: 1, shots_on_target: 1, shots_off_target: 2, chances_created: 2, successful_dribbles: 3, saves: 0, successful_tib: 2 } },
    { name: 'Jad', side: 'B', rating: 7.6, s: { goals: 1, assists: 0, shots_on_target: 0, shots_off_target: 1, chances_created: 2, successful_dribbles: 2, saves: 0, successful_tib: 3 } },
    { name: 'Rony', side: 'B', rating: 7.2, s: { goals: 0, assists: 0, shots_on_target: 0, shots_off_target: 0, chances_created: 0, successful_dribbles: 0, saves: 5, successful_tib: 1 } },
    { name: 'Elie', side: 'B', rating: 6.9, s: { goals: 0, assists: 1, shots_on_target: 1, shots_off_target: 2, chances_created: 1, successful_dribbles: 2, saves: 0, successful_tib: 4 } },
    { name: 'Fadi', side: 'B', rating: 6.5, s: { goals: 0, assists: 0, shots_on_target: 0, shots_off_target: 1, chances_created: 1, successful_dribbles: 1, saves: 0, successful_tib: 3 } },
  ],
  reel: '2:48',
  myReel: '0:46',
  events: [
    ["12'", 'Goal', '#10B981', 'Karl', 'A'], ["19'", 'Dribble', '#06B6D4', 'Ali', 'A'], ["31'", 'Goal', '#10B981', 'Omar', 'A'],
    ["36'", 'Save', '#F59E0B', 'Rony', 'B'], ["40'", 'Goal', '#10B981', 'Sami', 'B'], ["48'", 'Save', '#F59E0B', 'Marc', 'A'],
    ["54'", 'Goal', '#10B981', 'Karl', 'A'], ["57'", 'Goal', '#10B981', 'Jad', 'B'],
  ],
  clips: [
    { time: '12:04', type: 'goal', duration: 9 },
    { time: '18:40', type: 'dribble', duration: 7 },
    { time: '27:15', type: 'assist', duration: 8 },
    { time: '43:02', type: 'chance', duration: 6 },
    { time: '54:22', type: 'goal', duration: 9 },
  ],
  tableColumns: [['G', 'goals'], ['A', 'assists'], ['SOT', 'shots_on_target'], ['SOF', 'shots_off_target'], ['CH', 'chances_created'], ['DRB', 'successful_dribbles'], ['SV', 'saves']],
}

const BASKETBALL = {
  sport: 'basketball',
  home: 'Cedars',
  away: 'Hoops United',
  score: '68 - 61',
  community: 'Downtown Hoops',
  when: 'Tuesday · 9:00 PM',
  dateLabel: 'Tue, Oct 27',
  timeLabel: '9:00 PM',
  datePlayed: '2026-10-27',
  hourSlot: '21:00',
  venueName: 'Hoops Arena',
  venue: 'Court 1',
  keyCode: 'DTH-1093',
  minutes: 40,
  you: 'Karl',
  quarters: [['Q1', 18, 14], ['Q2', 15, 17], ['Q3', 19, 12], ['Q4', 16, 18]],
  players: [
    { name: 'Karl', side: 'A', rating: 8.9, s: { points: 24, fg_made: 9, fg_attempted: 17, three_made: 4, three_attempted: 8, ft_made: 2, ft_attempted: 2, assists: 5, offensive_rebound: 2, defensive_rebound: 5, blocks: 1, turnovers: 2 } },
    { name: 'Rami', side: 'A', rating: 7.8, s: { points: 15, fg_made: 6, fg_attempted: 13, three_made: 1, three_attempted: 4, ft_made: 2, ft_attempted: 3, assists: 4, offensive_rebound: 2, defensive_rebound: 4, blocks: 0, turnovers: 3 } },
    { name: 'Ziad', side: 'A', rating: 7.2, s: { points: 12, fg_made: 5, fg_attempted: 10, three_made: 1, three_attempted: 3, ft_made: 1, ft_attempted: 2, assists: 3, offensive_rebound: 3, defensive_rebound: 6, blocks: 2, turnovers: 2 } },
    { name: 'Nour', side: 'A', rating: 6.9, s: { points: 10, fg_made: 4, fg_attempted: 9, three_made: 1, three_attempted: 3, ft_made: 1, ft_attempted: 2, assists: 2, offensive_rebound: 2, defensive_rebound: 6, blocks: 1, turnovers: 2 } },
    { name: 'Paul', side: 'A', rating: 6.6, s: { points: 7, fg_made: 2, fg_attempted: 6, three_made: 0, three_attempted: 1, ft_made: 3, ft_attempted: 4, assists: 1, offensive_rebound: 3, defensive_rebound: 5, blocks: 0, turnovers: 2 } },
    { name: 'Joe', side: 'B', rating: 8.4, s: { points: 21, fg_made: 8, fg_attempted: 16, three_made: 3, three_attempted: 7, ft_made: 2, ft_attempted: 3, assists: 4, offensive_rebound: 1, defensive_rebound: 5, blocks: 2, turnovers: 3 } },
    { name: 'Tony', side: 'B', rating: 7.5, s: { points: 12, fg_made: 5, fg_attempted: 11, three_made: 1, three_attempted: 3, ft_made: 1, ft_attempted: 2, assists: 3, offensive_rebound: 3, defensive_rebound: 4, blocks: 3, turnovers: 3 } },
    { name: 'Chris', side: 'B', rating: 7.0, s: { points: 11, fg_made: 4, fg_attempted: 10, three_made: 1, three_attempted: 4, ft_made: 2, ft_attempted: 2, assists: 2, offensive_rebound: 2, defensive_rebound: 4, blocks: 0, turnovers: 2 } },
    { name: 'Rabih', side: 'B', rating: 6.7, s: { points: 10, fg_made: 4, fg_attempted: 9, three_made: 0, three_attempted: 1, ft_made: 2, ft_attempted: 3, assists: 2, offensive_rebound: 2, defensive_rebound: 5, blocks: 1, turnovers: 3 } },
    { name: 'Georges', side: 'B', rating: 6.3, s: { points: 7, fg_made: 2, fg_attempted: 6, three_made: 0, three_attempted: 2, ft_made: 3, ft_attempted: 4, assists: 1, offensive_rebound: 1, defensive_rebound: 4, blocks: 0, turnovers: 3 } },
  ],
  reel: '3:12',
  myReel: '0:52',
  events: [
    ['Q1', 'Three', '#10B981', 'Karl', 'A'], ['Q1', 'Block', '#F59E0B', 'Tony', 'B'], ['Q2', 'Assist', '#3B82F6', 'Rami', 'A'],
    ['Q2', 'Three', '#10B981', 'Joe', 'B'], ['Q3', 'Rebound', '#06B6D4', 'Ziad', 'A'], ['Q3', 'Three', '#10B981', 'Karl', 'A'],
    ['Q4', 'Three', '#10B981', 'Joe', 'B'], ['Q4', 'Three', '#10B981', 'Karl', 'A'],
  ],
  momentum: [['Q1', 3, 'A'], ['Q1', 4, 'B'], ['Q1', 7, 'A'], ['Q2', 14, 'B'], ['Q2', 17, 'A'], ['Q2', 18, 'B'], ['Q3', 23, 'A'], ['Q3', 26, 'A'], ['Q3', 28, 'A'], ['Q4', 33, 'B'], ['Q4', 36, 'B'], ['Q4', 38, 'A']],
  clips: [
    { time: '03:12', type: 'highlight', label: 'Three Pointer', duration: 7 },
    { time: '09:40', type: 'assist', duration: 6 },
    { time: '17:05', type: 'highlight', label: 'Rebound', duration: 6 },
    { time: '26:48', type: 'highlight', label: 'Three Pointer', duration: 7 },
    { time: '38:20', type: 'highlight', label: 'Block', duration: 5 },
  ],
  tableColumns: [['PTS', 'points'], ['FGM', 'fg_made'], ['3PM', 'three_made'], ['A', 'assists'], ['REB', 'rebounds'], ['BLK', 'blocks'], ['TO', 'turnovers']],
}

const PADEL = {
  sport: 'padel',
  home: 'Team A',
  away: 'Team B',
  generic: true,
  score: '2 - 1',
  community: 'Sunset Padel Club',
  when: 'Saturday · 6:00 PM',
  dateLabel: 'Sat, Oct 31',
  timeLabel: '6:00 PM',
  datePlayed: '2026-10-31',
  hourSlot: '18:00',
  venueName: 'Sunset Padel Club',
  venue: 'Court 2',
  keyCode: 'SPC-7730',
  minutes: 75,
  you: 'Karl',
  players: [
    { name: 'Karl', side: 'A', rating: 8.7, s: { serve: 14, return: 10, ace: 3, winner: 9, smash: 4, lob: 6, dropshot: 3, long_rally: 5, double_faults: 1, unforced_errors: 4 } },
    { name: 'Omar', side: 'A', rating: 7.6, s: { serve: 11, return: 9, ace: 1, winner: 6, smash: 2, lob: 5, dropshot: 2, long_rally: 4, double_faults: 2, unforced_errors: 6 } },
    { name: 'Sami', side: 'B', rating: 7.9, s: { serve: 12, return: 8, ace: 2, winner: 7, smash: 3, lob: 4, dropshot: 2, long_rally: 5, double_faults: 2, unforced_errors: 5 } },
    { name: 'Jad', side: 'B', rating: 6.8, s: { serve: 9, return: 7, ace: 0, winner: 4, smash: 1, lob: 6, dropshot: 3, long_rally: 3, double_faults: 3, unforced_errors: 7 } },
  ],
  reel: '2:35',
  myReel: '0:41',
  events: [
    ['S1', 'Ace', '#10B981', 'Karl', 'A'], ['S1', 'Winner', '#10B981', 'Sami', 'B'], ['S1', 'Smash', '#F59E0B', 'Karl', 'A'],
    ['S2', 'Lob', '#06B6D4', 'Jad', 'B'], ['S2', 'Dropshot', '#8B5CF6', 'Omar', 'A'], ['S3', 'Rally', '#3B82F6', 'Sami', 'B'],
    ['S3', 'Winner', '#10B981', 'Karl', 'A'],
  ],
  momentum: [['S1', 6, 'A'], ['S1', 11, 'A'], ['S1', 18, 'B'], ['S1', 22, 'A'], ['S2', 31, 'B'], ['S2', 36, 'B'], ['S2', 44, 'B'], ['S3', 52, 'A'], ['S3', 58, 'A'], ['S3', 63, 'B'], ['S3', 70, 'A']],
  clips: [
    { time: '04:18', type: 'ace', duration: 5 },
    { time: '12:50', type: 'smash', duration: 6 },
    { time: '27:33', type: 'lob', duration: 7 },
    { time: '41:09', type: 'long_rally', duration: 12 },
    { time: '66:45', type: 'winner', duration: 6 },
  ],
  tableColumns: [['WIN', 'winner'], ['ACE', 'ace'], ['SMA', 'smash'], ['LOB', 'lob'], ['DRP', 'dropshot'], ['UE', 'unforced_errors']],
}

const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0)

function statValue(sport, key, s) {
  if (key === 'rebounds') return n(s.offensive_rebound) + n(s.defensive_rebound)
  if (sport === 'football' && key === 'shots_on_target') return n(s.shots_on_target) + n(s.goals)
  if (sport === 'football' && key === 'total_shots') return n(s.shots_on_target) + n(s.goals) + n(s.shots_off_target)
  if (sport === 'padel' && key === 'points') return n(s.serve) + n(s.return)
  return n(s[key])
}

function sum(players, side, sport, key) {
  return players.filter((p) => p.side === side).reduce((acc, p) => acc + statValue(sport, key, p.s), 0)
}

/** Same rows and labels as buildTeamStatRows in utils/matchTempStatsAggregation.ts. */
const TEAM_ROWS = {
  football: [['Goals', 'goals'], ['Assists', 'assists'], ['Shots on target', 'shots_on_target'], ['Shots off target', 'shots_off_target'], ['Chances', 'chances_created'], ['Saves', 'saves'], ['TIB', 'successful_tib'], ['Dribbles', 'successful_dribbles']],
  basketball: [['Points', 'points'], ['3PT made', 'three_made'], ['Assists', 'assists'], ['Rebounds', 'rebounds'], ['Blocks', 'blocks'], ['Turnovers', 'turnovers']],
  padel: [['Rally pts', 'points'], ['Winner stat', 'winner'], ['Aces', 'ace'], ['Smashes', 'smash'], ['Unforced', 'unforced_errors']],
}

/** statsByImportanceForSport in utils/playerStatRankings.ts. */
const RANKED_STATS = {
  football: [['goals', 'Goals'], ['assists', 'Assists'], ['chances_created', 'Chances created'], ['shots_on_target', 'Shots on target'], ['total_shots', 'Total shots'], ['successful_dribbles', 'Successful dribbles'], ['saves', 'Saves'], ['successful_tib', 'Successful TIB']],
  basketball: [['points', 'Points'], ['three_made', '3PT Made'], ['fg_made', 'FG Made'], ['ft_made', 'FT Made'], ['assists', 'Assists'], ['offensive_rebound', 'Off. Rebounds'], ['defensive_rebound', 'Def. Rebounds'], ['blocks', 'Blocks'], ['turnovers', 'Turnovers']],
  padel: [['points', 'Points'], ['winner', 'Winners'], ['ace', 'Aces'], ['smash', 'Smashes'], ['dropshot', 'Dropshots'], ['lob', 'Lobs'], ['return', 'Returns']],
}

function plural(count, one, many) {
  return count === 1 ? one : many ?? `${one}s`
}

/** Award order, labels, colours and stat lines from utils/matchAwards.ts. */
const AWARDS = {
  football: [
    ['top_scorer', 'Top Scorer', '#14B8A6', 'FootballIcon', (s) => n(s.goals), (v) => `${v} ${plural(v, 'goal')}`],
    ['assist_king', 'Assist King', '#2e5fc7', 'Clapping01Icon', (s) => n(s.assists), (v) => `${v} ${plural(v, 'assist')}`],
    ['magic_feet', 'Magic Feet', '#A78BFA', 'RunningShoesIcon', (s) => n(s.successful_dribbles), (v) => `${v} successful ${plural(v, 'dribble')}`],
    ['wall_of_steel', 'Wall of Steel', '#FBBF24', 'Shield01Icon', (s) => n(s.successful_tib), (v) => `${v} defensive ${plural(v, 'action')}`],
    ['safe_hands', 'Safe Hands', '#22C55E', 'GloveIcon', (s) => n(s.saves), (v) => `${v} ${plural(v, 'save')}`],
  ],
  basketball: [
    ['scoring_machine', 'Scoring Machine', '#FFD700', 'ChampionIcon', (s) => n(s.points), (v) => `${v} ${plural(v, 'point')}`],
    ['three_pt_sniper', 'Three-Point Sniper', '#EF4444', 'Target02Icon', (s) => n(s.three_made), (v) => `${v} three-${plural(v, 'pointer')}`],
    ['free_throw_king', 'Free Throw King', '#F97316', 'Basketball01Icon', (s) => n(s.ft_made), (v) => `${v} free ${plural(v, 'throw')}`],
    ['glass_cleaner', 'Glass Cleaner', '#22C55E', 'Basketball01Icon', (s) => n(s.offensive_rebound) + n(s.defensive_rebound), (v) => `${v} ${plural(v, 'rebound')}`],
    ['the_wall', 'The Wall', '#8B5CF6', 'BoxingGloveIcon', (s) => n(s.blocks), (v) => `${v} ${plural(v, 'block')}`],
    ['bball_playmaker', 'Playmaker', '#F97316', 'Clapping01Icon', (s) => n(s.assists), (v) => `${v} ${plural(v, 'assist')}`],
  ],
  padel: [
    ['service_sniper', 'Service Sniper', '#F97316', 'Target02Icon', (s) => (n(s.serve) > 0 ? Math.round(((n(s.serve) - n(s.double_faults)) / n(s.serve)) * 100) : 0), (v) => `${v}% serve accuracy`],
    ['finesse_god', 'Finesse God', '#8B5CF6', 'BadmintonShuttleIcon', (s) => n(s.lob) + n(s.dropshot), (v) => `${v} finesse ${plural(v, 'shot')}`],
    ['smash_berzerker', 'Smash Berzerker', '#EF4444', 'TennisRacketIcon', (s) => n(s.smash), (v) => `${v} ${plural(v, 'smash', 'smashes')}`],
    ['the_finisher', 'The Finisher', '#22C55E', 'WhistleIcon', (s) => n(s.winner), (v) => `${v} ${plural(v, 'winner')}`],
  ],
}

function buildAwards(game) {
  const mvp = [...game.players].sort((a, b) => b.rating - a.rating)[0]
  const awards = [
    { key: 'mvp', label: 'Man of the Match', color: '#FFD700', icon: 'ChampionIcon', stat: `rated ${mvp.rating.toFixed(1)}`, winners: [mvp.name] },
  ]
  for (const [key, label, color, icon, value, line] of AWARDS[game.sport]) {
    const best = Math.max(...game.players.map((p) => value(p.s)))
    if (best <= 0) continue
    const winners = game.players.filter((p) => value(p.s) === best).map((p) => p.name)
    awards.push({ key, label, color, icon, stat: line(best), winners })
  }
  return awards
}

function buildRankings(game) {
  const sorted = (valueOf) => [...game.players].map((p) => ({ name: p.name, value: valueOf(p) })).sort((a, b) => b.value - a.value)
  const rankings = [{ key: 'match_rating', label: 'Match rating', decimals: 1, players: sorted((p) => p.rating) }]
  for (const [key, label] of RANKED_STATS[game.sport]) {
    const players = sorted((p) => statValue(game.sport, key, p.s))
    if (players.some((p) => p.value > 0)) rankings.push({ key, label, players })
  }
  return rankings
}

function buildPointsScorers(game, side) {
  return game.players
    .filter((p) => p.side === side)
    .map((p) => ({ name: p.name, pts: statValue(game.sport, 'points', p.s), isYou: p.name === game.you }))
    .filter((p) => p.pts > 0)
    .sort((a, b) => b.pts - a.pts)
    .slice(0, 3)
    .map((p) => ({ name: p.name, valueLine: `${p.pts} pts`, isYou: p.isYou }))
}

function buildGame(base) {
  const { sport, players } = base
  const me = players.find((p) => p.name === base.you)
  const game = {
    ...base,
    mine: me.s,
    rating: me.rating,
    teamRows: TEAM_ROWS[sport].map(([label, key]) => [label, sum(players, 'A', sport, key), sum(players, 'B', sport, key)]),
    rankings: buildRankings(base),
    awards: buildAwards(base),
    tableHome: players.filter((p) => p.side === 'A').map((p) => [p.name, ...base.tableColumns.map(([, key]) => statValue(sport, key, p.s)), p.rating.toFixed(1)]),
    tableAway: players.filter((p) => p.side === 'B').map((p) => [p.name, ...base.tableColumns.map(([, key]) => statValue(sport, key, p.s)), p.rating.toFixed(1)]),
  }
  game.team = game.teamRows
  game.tableColumns = base.tableColumns.map(([label]) => label)
  if (sport === 'basketball' || sport === 'padel') {
    game.pointsHome = buildPointsScorers(base, 'A')
    game.pointsAway = buildPointsScorers(base, 'B')
  }
  if (sport === 'padel') {
    game.splitHome = { serve: sum(players, 'A', sport, 'serve'), returnPts: sum(players, 'A', sport, 'return') }
    game.splitAway = { serve: sum(players, 'B', sport, 'serve'), returnPts: sum(players, 'B', sport, 'return') }
  }
  if (!base.momentum) {
    game.momentum = base.events.map(([minute, type, , , side]) => [type, parseInt(minute, 10), side])
  }
  return game
}

export const SAMPLE_GAMES = {
  Football: buildGame(FOOTBALL),
  Basketball: buildGame(BASKETBALL),
  Padel: buildGame(PADEL),
}
